import { module } from 'angular';
import { KAYENTA_MODULE } from '@spinnaker/kayenta';
import './metricStore/index';

export const ARMORY_KAYENTA_MODULE = 'spinnaker.armory.kayenta';
module(ARMORY_KAYENTA_MODULE, [KAYENTA_MODULE]);
